// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xmyl","label":"styles_label__2c2x_"};